import { ApplicationConfig, LOCALE_ID, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';

import { NgxMapboxGLModule } from 'ngx-mapbox-gl';
import { ENVIRONMENT } from '../environments/environment.type';
import { environmentFactory } from '../environments/environment.factory';
import { headersInterceptor } from './shared/interceptors/headers.interceptor';
import localePt from '@angular/common/locales/pt';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { registerLocaleData } from '@angular/common';
import { routes } from './app.routes';
import TmTheme from './tm-theme';
import { DynamicTitleStrategy } from './shared/services/dynamic-title.strategy';
import { providePwa } from './shared/app-ui/pwa/pwa.providers';
import { appOverlayListener } from './shared/app-ui/utils/app-overlay-listener';
import { TitleStrategy } from '@angular/router';

import { provideEchartsCore } from 'ngx-echarts'; // ✅ importação correta

registerLocaleData(localePt);

const baseProviders = [
  { provide: ENVIRONMENT, useFactory: environmentFactory },
  MessageService,
  provideZoneChangeDetection({ eventCoalescing: true }),
  provideRouter(routes),
  provideAnimationsAsync(),
  provideHttpClient(withInterceptors([headersInterceptor])),
  importProvidersFrom(
    NgxMapboxGLModule.withConfig({
      accessToken: environmentFactory().mapboxToken,
    }),
  ),
  importProvidersFrom(),
  provideEchartsCore({
    echarts: () => import('echarts'), // ✅ lazy loading seguro
  }),
  { provide: LOCALE_ID, useValue: 'pt-BR' },
  providePrimeNG({
    overlayOptions: { listener: appOverlayListener },
    theme: {
      preset: TmTheme,
      options: {
        darkModeSelector: false,
      },
    },
    translation: {
      firstDayOfWeek: 0,
      dayNames: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
      dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
      dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
      monthNames: [
        'janeiro',
        'fevereiro',
        'março',
        'abril',
        'maio',
        'junho',
        'julho',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'dezembro',
      ],
      monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
      today: 'Hoje',
      clear: 'Limpar',
      selectionMessage: '{0} itens selecionados',
      dateFormat: 'dd/mm/yy',
      weekHeader: 'Sem',
      accept: 'Aceitar',
      reject: 'Rejeitar',
    },
  }),
  // máscara
  provideEnvironmentNgxMask({
    validation: true, // impede letras, aceita apenas dígitos válidos para a máscara
  }),
  { provide: TitleStrategy, useClass: DynamicTitleStrategy },
  ...providePwa(),
];

export const appConfig: ApplicationConfig = {
  providers: [...baseProviders],
};
